import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
} from "reactstrap";
import classnames from "classnames";
import { isEmpty, map } from "lodash";

//Import Star Ratings
import StarRatings from "react-star-ratings";

//Import Product Images
import { productImages } from "assets/images/product";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";

//Import actions
import { getAds as onGetProducts, deleteAd } from "store/home-ads/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import Spinners from "components/Common/Spinner";

const EcommerceProducts = () => {

  //meta title
  document.title = "Ads | Immagoo";

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectEcommerceState = (state) => state.HomeAds;
  const EcommerceProductsProperties = createSelector(
    selectEcommerceState,
    (Ecommerce) => console.log(Ecommerce) || ({
      ads: Ecommerce.ads,
      loading: Ecommerce.loading
    })
  );

  const {
    ads,
    loading,
  } = useSelector(EcommerceProductsProperties);

  const [isLoading, setLoading] = useState(loading)

  const [productList, setProductList] = useState([]);

  useEffect(() => {
    dispatch(onGetProducts());
  }, [dispatch]);

  useEffect(() => {
    if (!isEmpty(ads)) setProductList(ads);
  }, [ads]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            breadcrumbItem="Estate Ads"
          >
            <Button color="primary" className="btn" onClick={() => navigate('/add-ad')}>
              New
            </Button>
          </Breadcrumbs>
          <Row>
            <Col lg={12}>
              {isLoading
                ? <Spinners setLoading={setLoading} />
                : <Row>
                    {!isEmpty(ads) && (ads || []).map((product, key) => (
                        <Col xl={4} sm={6} key={"_col_" + key}>
                          <Card >
                            <CardBody>
                              <div className="product-img position-relative">
                                <div
                                    className="avatar-sm product-ribbon"
                                    style={{ cursor: 'pointer', right: 70 }}
                                    onClick={() => navigate('/edit-ad/'+product._id)}
                                >
                                      <span className="avatar-title rounded-circle bg-secondary">
                                        <i className="bx bx-edit font-size-22"></i>
                                      </span>
                                </div>
                                <div
                                    className="avatar-sm product-ribbon"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => dispatch(deleteAd(product._id))}
                                >
                                      <span className="avatar-title rounded-circle bg-secondary">
                                        <i className="bx bx-trash font-size-22"></i>
                                      </span>
                                </div>

                                <img
                                    style={{ height: '330px' }}
                                    src={product?.photos?.[0]}
                                    className="img-fluid mx-auto d-block"
                                />
                              </div>
                              <div className="mt-4 text-center">
                                <h5 className="mb-3 text-truncate">
                                  {product.location?.address}{' '}<br />
                                  {product.location?.locality}{' '}<br />
                                  {product.location?.postalCode}{' '}
                                </h5>
                                <h5 className="my-0">
                                  <b>{product.price.main} {product.price.currency}</b>
                                </h5>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      ))}
                  </Row>
              }
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

EcommerceProducts.propTypes = {
  ads: PropTypes.array,
  onGetProducts: PropTypes.func,
};

export default withRouter(EcommerceProducts);
